<template>
  <div class="custom-form-item">
    <div class="form-title-switch">
      <div class="form-title-switch-text">
        <div>加价</div>
        <el-tooltip class="item" effect="dark" content="市场价加价是，给市场价进行虚拟加价，快出加价是对快出票进行实际加价" placement="top">
          <i class="el-icon-question"></i>
        </el-tooltip>
      </div>
      <el-switch
          class="form-title-switch-switch"
          v-model="form.virtualMarkupSwitch"
          :active-value="1"
          :inactive-value="0"
      />
      <div style="color: #999999;margin-left: 20px">开关关闭，加价规则不生效；反之，则加价规则生效</div>
    </div>

    <div class="add-price-content">
      <el-form
          ref="formRef"
          :model="form"
          :rules="rules"
          size="small"
      >

        <div
            v-for="(item, index) in form.list"
            :key="index"
            style="display: flex;gap: 10px; align-items: flex-start; border-bottom: solid 1px #ddd;padding:10px 0;margin: 10px 0"
        >
          <div style="line-height: 30px">{{index + 1}}.影院分类</div>
          <el-form-item style="margin-right: 10px" :prop="'list.' + index + '.categoryList'">
            <el-select
                style="width: 180px"
                v-model="item.categoryList"
                filterable
                multiple
                reserve-keyword
                value-key="id"
                placeholder="请选择"
            >
              <el-option
                v-for="option in cinemaClassifyOptions"
                :key="option.id"
                :label="option.name"
                :value="option"
                :disabled="handleDisabledOption(index, option)"
              />
            </el-select>
          </el-form-item>

          <!-- 规则明细 -->
          <div class="rule">
            <div
                v-for="(rule, ruleIndex) in item.ruleList"
                :key="`rule-${index}-${ruleIndex}`"
                class="rule-item"
            >
              <div style="display: flex;gap: 5px; align-items: flex-start">
                <div style="line-height: 30px;font-weight: bold;color: #000">市场价区间：</div>
                <div style="line-height: 30px"></div>
                <el-form-item
                    style="display: flex;align-items: center;"
                    :prop="`list.${index}.ruleList.${ruleIndex}.marketPriceMin`"
                    label-width="0"
                >
                  <el-input placeholder="最小值(>=)，0到9999" style="width: 180px" v-model="rule.marketPriceMin" />
                </el-form-item>
                <div style="line-height: 30px">-</div>
                <el-form-item
                    :prop="`list.${index}.ruleList.${ruleIndex}.marketPriceMax`"
                    label-width="0"
                >
                  <el-input placeholder="最大值(<)，0到9999" style="width: 180px" v-model="rule.marketPriceMax" />
                </el-form-item>
              </div>

              <div style="display: flex; flex-direction: column; gap: 10px;">
                <!-- 市场价加价 -->
                <div style="display: flex;gap: 5px; align-items: flex-start">
                  <div style="line-height: 30px;font-weight: bold;color: #000; min-width: 90px">市场价加价：</div>
                  <div style="line-height: 30px">市场价 ×</div>
                  <el-form-item
                      style="display: flex;align-items: center;"
                      :prop="`list.${index}.ruleList.${ruleIndex}.addPercent`"
                      label-width="0"
                  >
                    <el-input placeholder="0~50" style="width: 130px" v-model="rule.addPercent" >
                      <div slot="suffix">%</div>
                    </el-input>
                  </el-form-item>
                  <div style="line-height: 30px">+</div>
                  <div style="line-height: 30px">固定加价金额</div>
                  <el-form-item
                      :prop="`list.${index}.ruleList.${ruleIndex}.addFix`"
                      label-width="0"
                  >
                    <el-input placeholder="0~20" style="width: 130px" v-model="rule.addFix" >
                      <div slot="suffix">元</div>
                    </el-input>
                  </el-form-item>
                </div>

                <!-- 快出价加价 -->
                <div style="display: flex;gap: 5px; align-items: flex-start" v-if="form.fastVirtualMarkupPermission">
                  <div style="line-height: 30px;font-weight: bold;color: #000; min-width: 90px;">快出加价：</div>
                  <div style="line-height: 30px">市场价 ×</div>
                  <el-form-item
                      style="display: flex;align-items: center;"
                      :prop="`list.${index}.ruleList.${ruleIndex}.fastAddPercent`"
                      label-width="0"
                  >
                    <el-input placeholder="0~30" style="width: 130px" v-model="rule.fastAddPercent" >
                      <div slot="suffix">%</div>
                    </el-input>
                  </el-form-item>
                  <div style="line-height: 30px">+</div>
                  <div style="line-height: 30px">固定加价金额</div>
                  <el-form-item
                      :prop="`list.${index}.ruleList.${ruleIndex}.fastAddFix`"
                      label-width="0"
                  >
                    <el-input placeholder="0~5" style="width: 130px" v-model="rule.fastAddFix" >
                      <div slot="suffix">元</div>
                    </el-input>
                  </el-form-item>
                </div>
              </div>



              <div style="display: flex;flex:1;gap: 8px; align-items: flex-start;justify-content: flex-end;margin-left: 5px">
                <el-button
                    v-show="ruleIndex === item.ruleList.length - 1"
                    icon="el-icon-circle-plus-outline"
                    type="primary"
                    size="mini"
                    style="padding: 8px; border-radius: 6px"
                    @click="handleAddVirtualItemMarkup(item)"
                >
                  新增区间
                </el-button>
                <el-button
                    icon="el-icon-remove-outline"
                    size="mini"
                    type="danger"
                    style="padding: 8px; border-radius: 6px"
                    @click="handleDeleteVirtualItemMarkup(item, ruleIndex, index)"
                >
                  删除
                </el-button>
              </div>
            </div>
          </div>
          <i style="font-size: 22px" class="el-icon-delete" @click="handleDeleteVirtualItem(index)"></i>
        </div>
      </el-form>
    </div>
    <el-button class="add-price-btn" icon="el-icon-circle-plus-outline" type="primary" @click="handleAddVirtualItem">新增</el-button>
  </div>
</template>

<script>
import AddPriceApi from '@/api/addPrice'

const addPriceApi = new AddPriceApi()
export default {
  data() {
    return {
      form:{
        virtualMarkupSwitch: false,
        fastVirtualMarkupPermission: false,
        list: [],
      },
      cinemaClassifyOptions:[],
      rules: {},
      test:"",
    }
  },
  async created() {
    await this.init()
    await this.getAndSetOptions()
    await this.generateRules()
  },
  // 监听 form.list 变化，动态生成规则
  watch: {
    'form.list': {
      handler(_newVal, _oldVal) {
        this.generateRules()
      },
      deep: true,
    },
  },
  methods:{
    // 🧩 动态规则生成
    async generateRules() {
      const rules = {}

      // 校验是否是数字、最多两位小数、范围
      const numberValidator = (fieldName, min, max) => {
        return (_, val, cb) => {
          if (val === '' || val === null || val === undefined) return cb()
          const num = parseFloat(val)
          if (isNaN(num)) return cb(new Error(`${fieldName}必须是数字`))
          if (!/^\d+(\.\d{1,2})?$/.test(val)) return cb(new Error(`${fieldName}最多保留两位小数`))
          if (num < min || num > max) return cb(new Error(`${fieldName}范围必须在 ${min}~${max}`))
          cb()
        }
      }

      // 遍历每个组
      this.form.list.forEach((group, groupIndex) => {
        const groupPath = `list.${groupIndex}`

        // 分类至少选一个 + 不重复
        rules[`${groupPath}.categoryList`] = [
          {
            validator: (_, val, cb) => {
              if (!val || val.length === 0) return cb(new Error('请至少选择一个分类'))

              const otherGroups = this.form.list.filter((_, i) => i !== groupIndex)
              const allOtherCats = otherGroups.flatMap(g => g.categoryList.map(c => c.id))
              const overlap = val.some(c => allOtherCats.includes(c.id))
              if (overlap) return cb(new Error('分类在其他组中已存在'))

              cb()
            },
            trigger: 'change',
          },
        ]

        // 遍历每条规则
        group.ruleList.forEach((_, ruleIndex) => {
          const basePath = `${groupPath}.ruleList.${ruleIndex}`

          // marketPriceMin
          rules[`${basePath}.marketPriceMin`] = [
            { required: true, message: '请输入最低价', trigger: 'blur' },
            { validator: numberValidator('最低价', 0, 9999), trigger: 'blur' },
            {
              validator: (_, val, cb) => {
                const maxVal = parseFloat(group.ruleList[ruleIndex].marketPriceMax)
                if (!isNaN(maxVal) && parseFloat(val) > maxVal) return cb(new Error('最低价不能大于最高价'))
                cb()
              },
              trigger: 'blur',
            },
          ]

          // marketPriceMax
          rules[`${basePath}.marketPriceMax`] = [
            { required: true, message: '请输入最高价', trigger: 'blur' },
            { validator: numberValidator('最高价', 0, 9999), trigger: 'blur' },
            {
              validator: (_, val, cb) => {
                const minVal = parseFloat(group.ruleList[ruleIndex].marketPriceMin)
                if (!isNaN(minVal) && parseFloat(val) < minVal) return cb(new Error('最高价不能小于最低价'))
                cb()
              },
              trigger: 'blur',
            },
            {
              validator: (_, val, cb) => {
                // 同组价格区间不重叠
                const currentMin = parseFloat(group.ruleList[ruleIndex].marketPriceMin)
                const currentMax = parseFloat(val)
                for (let i = 0; i < group.ruleList.length; i++) {
                  if (i === ruleIndex) continue
                  const r = group.ruleList[i]
                  const min = parseFloat(r.marketPriceMin)
                  const max = parseFloat(r.marketPriceMax)
                  if (!isNaN(min) && !isNaN(max)) {
                    if (!(currentMax <= min || currentMin >= max)) return cb(new Error('价格区间不能重叠'))
                  }
                }
                cb()
              },
              trigger: 'blur',
            },
          ]

          // addPercent
          rules[`${basePath}.addPercent`] = [
            { required: true, message: '请输入加成百分比', trigger: 'blur' },
            { validator: numberValidator('加成百分比', 0, 50), trigger: 'blur' },
          ]

          // addFix
          rules[`${basePath}.addFix`] = [
            { required: true, message: '请输入固定加成', trigger: 'blur' },
            { validator: numberValidator('固定加成', 0, 20), trigger: 'blur' },
          ]

          // fastAddPercent
          rules[`${basePath}.fastAddPercent`] = [
            { required: true, message: '请输入加成百分比', trigger: 'blur' },
            { validator: numberValidator('加成百分比', 0, 30), trigger: 'blur' },
          ]

          // fastAddFix
          rules[`${basePath}.fastAddFix`] = [
            { required: true, message: '请输入固定加成', trigger: 'blur' },
            { validator: numberValidator('固定加成', 0, 5), trigger: 'blur' },
          ]
        })
      })

      this.rules = rules
    },
    async handleDeleteVirtualItem(index, check = true){
      if(check){
        await this.$confirm(`确认删除第${index + 1}条配置吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
      }
      this.form.list.splice(index, 1)
    },
    async handleDeleteVirtualItemMarkup(item, ruleIndex, itemIndex) {
      // 只剩一条的话，整个项删除
      if(item.ruleList.length === 1){
        await this.handleDeleteVirtualItem(itemIndex, false)
        return;
      }
      item.ruleList.splice(ruleIndex, 1)
    },
    handleAddVirtualItemMarkup(item){
      // 不能超过20条
      if(item.ruleList.length >= 20){
        this.$message.error('最多只能新增20条区间')
        return;
      }
      const newRule = {
        marketPriceMin: null,
        marketPriceMax: null,
        addPercent: null,
        addFix: null,
        fastAddPercent: null,
        fastAddFix: null,
      }
      item.ruleList.push(newRule)
    },
    // 判断当前选项是否应禁用
    handleDisabledOption(index, option) {
      const others = this.form.list.filter((_, i) => i !== index)

      const hasAllCategory = this.form.list.some(item =>
          item.categoryList.some(cat => cat.id === 0)
      )

      const othersContainOption = others.some(item =>
          item.categoryList.some(cat => cat.id === option.id)
      )

      if (option.id === 0) {
        // “全部分类” 禁用条件：
        // 1. 已被其他项选中过，或
        // 2. 存在任意非 0 分类被选择
        const hasNonAllCategory = this.form.list.some(item =>
            item.categoryList.some(cat => cat.id !== 0)
        )
        return othersContainOption || hasNonAllCategory
      }

      // 非“全部分类”禁用条件：
      // 若任一项中包含“全部分类”或已被其他项选中过
      return hasAllCategory || othersContainOption
    },
    async getAndSetOptions(){
      const res = await addPriceApi.getCinemaClassify({})
      if(!res.data.success){
        this.$message.error(res.data.msg)
        return;
      }
      this.cinemaClassifyOptions = res.data.data
      // 初始化时，在id = 0的时候增加文案（与其他分类互斥）
      const temp = this.cinemaClassifyOptions.find(cat => cat.id === 0)
      temp.name = temp.name+'（与其他分类互斥）'
    },
    async init(){
      // 初始化虚拟加价规则
      const res = await addPriceApi.getMarkUpRules({
        id: localStorage.getItem("appKeyMini")
      })

      if(!res.data.success){
        this.$message.error(res.data.msg)
        return;
      }
      this.form.list = res.data.data
    },
    handleAddVirtualItem(){
      // 存在分类未被选择，给出下标
      const index = this.form.list.findIndex(item => item.categoryList.length === 0)
      if(index !== -1){
        this.$message.error(`第${index+1}项分类未被选择，请选择分类后新增`)
        return;
      }

      // 如果已选择“全部分类”，则不能新增
      if(this.form.list.some(item => item.categoryList.some(cat => cat.id === 0))){
        this.$message.error('已选全部影院分类，无法新增分类')
        return;
      }

      // 选择出未使用过的分类
      const usedCategoryIds = this.form.list.flatMap(item => item.categoryList.map(cat => cat.id))
      // 过滤出未使用过的分类
      let availableCategories = this.cinemaClassifyOptions.filter(cat => !usedCategoryIds.includes(cat.id))
      // 如果已选择其他分类，需要剔除“全部分类”
      if(usedCategoryIds.length > 0){
        availableCategories = availableCategories.filter(cat => cat.id !== 0)
      }
      // 如果没有可用分类，直接返回
      if(availableCategories.length === 0){
        this.$message.error('当前已无可使用的分类')
        return;
      }

      const temp = {
        categoryList: [availableCategories[0]],
        ruleList: [{
          marketPriceMin: null,
          marketPriceMax: null,
          addPercent: null,
          addFix: null,
          fastAddPercent: null,
          fastAddFix: null
        }]
      }
      this.form.list.push(temp)
    },
    setVirtualMarkupSwitchByData(data){
      this.form.virtualMarkupSwitch = data.virtualMarkupSwitch
      this.form.fastVirtualMarkupPermission = data.fastVirtualMarkupPermission
    },
    async save(){
      await this.$refs.formRef.validate()

      const data = []
      this.form.list.forEach(item => {
        item.ruleList.forEach(rule => {
          const temp = {
            categoryIdList: item.categoryList.map(cat => cat.id),
            marketPriceMin: rule.marketPriceMin,
            marketPriceMax: rule.marketPriceMax,
            addPercent: rule.addPercent,
            addFix: rule.addFix,
            fastAddPercent: rule.fastAddPercent,
            fastAddFix: rule.fastAddFix,
          }
          data.push(temp)
        })
      })
      const res = await addPriceApi.saveMarkUpRules(data,{
        id: localStorage.getItem("appKeyMini")
      })

      if(!res.data.success){
        this.$message.error(res.data.msg)
        return Promise.reject();
      }
    }
  }
}
</script>

<style scoped lang="less">
.custom-form-item /deep/ .el-select__tags-text {
  max-width: 120px;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.custom-form-item /deep/ .el-tag{
  display: flex;
  align-items: baseline;
}

.custom-form-item{
  margin-top: 40px;
  .form-title-switch{
    border-left: 2px solid #ff8622;
    padding-left: 10px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;

    .form-title-switch-text{
      min-width: 160px;
      font-size: 16px;
      line-height: 15px;
      color: #222222;
      text-align: left;
      font-family: Alibaba-PuHuiTi-M;
      font-weight: 500;
      display: flex;
      gap: 10px;
    }

    .form-title-switch-switch{
      margin-left: 40px;
    }

    .form-title-switch-desc{
      color: #999;
      font-size: 14px;
      font-weight: 400;
      margin-left: 20px;
    }

  }
  .add-price-content{
    display: flex;
    flex-direction: column;
    max-height: 600px;
    overflow: auto;
    .add-price-item{
      display: flex;
      flex-direction: row;
      margin-bottom: 20px;

      .add-price-item-index{
        display: flex;
        align-items: center;
        width: 30px;
      }

      .add-price-item-title{
        display: flex;
        align-items: center;
        word-break: keep-all;
      }

      .add-price-item-select{
        display: flex;
        flex-direction: row;
      }

      .add-price-item-value{
        display: flex;
        flex-direction: row;
        margin-left: 20px;
      }

      .add-price-item-del{
        margin-left: 20px;
        width: 80px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  .add-price-btn{
    width: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .rule{
    display: flex;
    flex-direction: column;
    gap: 10px;
    justify-content: flex-start;
    .rule-item{
      display: flex;
      gap: 10px;
      border: #f1f1f1 1px solid;
      padding: 10px;
      border-radius: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pc/miniProgram/set/add-price.vue